import { useMutation } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useCompletePayment = (id: string) => {

  return useMutation({
    mutationFn: (data) => api.payments.competePayment(id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось провести платеж',
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Платеж успешно проведен',
        type: 'success',
      })
    }
  })
}
